"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyCreatePodcastV1ProjectsPodcastCreatePostQualityPreset = void 0;
exports.BodyCreatePodcastV1ProjectsPodcastCreatePostQualityPreset = {
    Standard: "standard",
    High: "high",
    Highest: "highest",
    Ultra: "ultra",
    UltraLossless: "ultra_lossless",
};
